import React from 'react'
import { Link , BrowserRouter } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import {GiJapan, GiUsaFlag } from 'react-icons/gi';

import { TiHome,TiSocialYoutubeCircular ,TiSocialLinkedinCircular,TiSocialGithubCircular} from 'react-icons/ti';
import { FaHackerrank } from 'react-icons/fa';
import { RiServiceFill } from 'react-icons/ri';
import { MdContactPhone } from 'react-icons/md';

import '../i18n';


const Navbar = () => {
    
    const { t, i18n } = useTranslation();
    const changeLanguage = (lng) => { i18n.changeLanguage(lng); }

    return ( 
 
        <nav class="navbar navbar-expand-lg navbar-light container">
            {/* logo */}
            <div class="border border-primary navbar-brand bg-warning rounded-circle">
                ソロ
            </div>

            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
            {/* <VscMenu/> */}
            </button>

            {/* list */}
            <div class="collapse navbar-collapse ml-auto" id="navbarSupportedContent">

            
            <ul class="navbar-nav mr-auto">
                
                <li class="nav-item active">
                    <Link class="nav-link text-dark" to="/">
                        <TiHome />
                        <small className="font-weight-bold" >{t('home')}</small>
                    </Link>
                </li>
                
                <li class="nav-item">
                    <Link class="nav-link text-dark" to="/services">
                        <RiServiceFill/> 
                        <small className="font-weight-bold"> {t('services')} </small>
                    </Link>
                </li>
               
                <li class="nav-item">
                    <Link class="nav-link text-dark" to="/contact">
                        <MdContactPhone/>
                        <small className="font-weight-bold"> {t('contact')}</small> 
                    </Link>
                </li>
              
                <li class="nav-item">
                    <Link class="nav-link text-dark" to="/portfolio"> 
                        <small className="font-weight-bold">{t('portfolio')} </small> 
                    </Link>
                </li>

                <li class="nav-item">
                    <Link class="nav-link text-dark" to="/about"> 
                        <small className="font-weight-bold">{t('about')}</small> 
                    </Link>
                </li>
                
            </ul>
            
            {/* social links */}
            <a className="social h4 p-1 text-dark" href="https://github.com/solisadeqi/"><TiSocialGithubCircular/></a>
            <a className="social h4 ml-2 p-1 text-primary" href="https://www.linkedin.com/in/soli-sadeqi"><TiSocialLinkedinCircular/></a>
            <a className="social h4 ml-2 p-1 text-danger" href="https://studio.youtube.com/channel/UCukPvg0XDYIoT76CY_JylXA"><TiSocialYoutubeCircular/></a>
            <a className="social h5 ml-2 p-2 text-success" href="https://www.hackerrank.com/solisadeqi"><FaHackerrank/></a>
            

            {/* language */}
            <ul class="navbar-nav ml-auto">
                <small className="d-flex">  
                    
                    <li className="nav-item pr-3 border-right border-dark"
                        onClick={() => changeLanguage('en')} >

                        <div className="flag">
                            <small className="font-weight-bold">enlish</small>
                            <GiUsaFlag className="mx-1 text-danger"/>
                        </div>

                    </li>
                    
                    <li className="nav-item pl-3"    
                        onClick={() => changeLanguage('jp')}>

                        <div className="flag">
                            <GiJapan className="mx-1 text-danger"/>
                            <small className="font-weight-bold">日本語</small>  
                        </div>

                    </li>

                </small>
            </ul>
    
            </div>
        </nav>
    
    )
}

export default Navbar
